export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 16-3ef8a100be08a4679057c2117ecc6036.png";